import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documentation-url',
  templateUrl: './documentation-url.component.html',
  styleUrls: ['./documentation-url.component.scss']
})
export class DocumentationUrlComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
